import React from 'react';
import { motion } from 'framer-motion';
import { prefersReducedMotion } from '../lib/motion';

const Reveal: React.FC<{ delay?: number; children: React.ReactNode }> = ({ delay = 0, children }) => {
  if (prefersReducedMotion()) {
    return <div>{children}</div>;
  }
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ duration: 0.5, delay, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
